import { IDS } from '../pnp-accred-action-id.constants';
import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import * as DocumentsListActions from './list.actions';
import {GRID_RELOAD} from "../../../../common/grid/grid.constants";

class PnpAccredListGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
    }

    $onInit() {
        this.module = 'pnp';
        this.identifier = IDS.pnpAccred;
        this.statePath = IDS.pnpAccredListGrid;
        this.filterTemplate = './list-grid-filter.html';
        this.exportComponent = false;
        this.title = false;
        this.icon = false;
        this.confirmDialogOnRemove = true;
        this.autoload = false;
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;

        this.columns = [
            {title: '#', mapper: null},
            {title: this.$filter('translate')('COMMON.DOCUMENT.DCR_NUMBER'),    mapper: 'template_number'},
            // {title: this.$filter('translate')('COMMON.FIELD.SITE_LOCATION'),    mapper: 'site_location'},
            {title: this.$filter('translate')('ACCREDITATION.COMMON.REQUIREMENT'),   mapper: 'section_name'},
            {title: this.$filter('translate')('COMMON.FIELD.NAME'),             mapper: 'template_name'},
            // {title: this.$filter('translate')('COMMON.FIELD.UPLOADED_BY'),      mapper: 'uploaded_by'},
            // {title: this.$filter('translate')('COMMON.DATE.ISSUE_DATE'),        mapper: 'uploaded_at'},
            // {title: this.$filter('translate')('COMMON.FIELD.APPROVED_BY'),      mapper: 'approved_by'},
            {title: this.$filter('translate')('COMMON.FIELD.APPROVAL_DATE'),    mapper: 'last_validation_at'},
            {title: this.$filter('translate')('COMMON.DATE.DUE_DATE'),          mapper: 'due_date'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), DocumentsListActions)(this);

        this.$scope.$on('LOCATION_SUBJECT_SELECTED', this.onLocationSelected.bind(this));

        this.dataAction = this.fetchPNPTemplatesListGrid;
        this.buttons.push({
            class: 'btnGridAction',
            label: this.$filter('translate')('COMMON.BUTTON.EXCLUDE'),
            callback: event => {
                this.onDetach(event);
            }
        });
        this.init();
        this.buttonsDefault = this.buttons.concat();
        this.hideDetachButton();
    }

    onLocationSelected(event, location) {
        if(['hof','slo','vsl'].includes(location.in_subject_basic_type_code)) {
            this.filter.loc_uuid = location.in_subject_uuid;
            this.$ngRedux.dispatch({
                type: GRID_RELOAD,
                id: IDS.pnpAccred,
                path: IDS.pnpAccredListGrid,
            })
        }

    }

    hideDeleteButton() {
        this.buttons = this.buttonsDefault.concat().filter(item => item.class !== 'btnGridRemove');
    }

    hideDetachButton() {
        this.buttons = this.buttonsDefault.concat().filter(item => item.class !== 'btnGridAction');
    }

    $onDestroy() {
        this.destroy();
    }

}

PnpAccredListGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope'];

export const pnpAccredListGrid = {
    bindings: {
        onSelect: '&',
        onRemove: '&',
        onDetach: '&',
    },
    controller: PnpAccredListGridController,
    ...gridTpl
}
